import { createContext, useContext } from "react";
import type { TimezoneMode } from "./dateTime";

export const DateDisplayContext = createContext<TimezoneMode>("utc");

export function useDisplayTimezone(): TimezoneMode {
  return useContext(DateDisplayContext);
}
